import { render, staticRenderFns } from "./TaskName.vue?vue&type=template&id=b9f1319a&"
import script from "./TaskName.vue?vue&type=script&lang=js&"
export * from "./TaskName.vue?vue&type=script&lang=js&"
import style0 from "./TaskName.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports